import { type ReactElement } from 'react'
import { Typography, Box, CircularProgress } from '@mui/material'
import EthHashInfo from '@/components/common/EthHashInfo'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import useWallet from '@/hooks/wallets/useWallet'

const SendingComponent = ({
  isShow,
  txHash,
  userOpHash,
  isDone = false,
}: {
  isShow: boolean
  txHash: string | undefined
  userOpHash: string | undefined
  isDone?: boolean
}): ReactElement => {
  const wallet = useWallet()

  if (!isShow) {
    return <></>
  }

  return (
    <Box textAlign="center">
      {!isDone && (
        <>
          <CircularProgress sx={{ color: '#5D5DFF' }} />
          <Typography
            sx={{
              mt: '16px',
              color: 'var(--Ebony-Clay-400, #AAB3CF)',
              fontSize: '18px',
              lineHeight: '160%',
              fontWeight: '600',
            }}
          >
            {userOpHash ? 'Waiting for network confirmation' : `Processing...`}{' '}
          </Typography>
          {userOpHash && (
            <Typography
              sx={{
                mt: '16px',
                color: 'var(--Ebony-Clay-300, #D2D7E5)',
                fontSize: '14px',
                lineHeight: '160%',
                fontWeight: '400',
              }}
            >
              UserOp Hash: {''}
              <span style={{ display: 'inline-block' }}>
                <EthHashInfo
                  address={userOpHash}
                  // hasExplorer
                  showCopyButton
                  showName={false}
                  shortAddress={true}
                  showAvatar={false}
                  shortenLen={12}
                  userOpHash={true}
                />
              </span>
            </Typography>
          )}
        </>
      )}
      {isDone && (
        <>
          <DoneAllIcon
            sx={{
              color: '#22C55E',
              fontSize: '48px',
              background: 'var(--Ebony-Clay-950, #2F354B)',
              borderRadius: '50%',
              padding: '8px',
            }}
          />
          <Typography
            sx={{
              mt: '16px',
              color: 'var(--Ebony-Clay-300, #D2D7E5)',
              fontSize: '20px',
              lineHeight: '160%',
              fontWeight: 'bold',
            }}
          >
            Transaction completed!
          </Typography>
        </>
      )}
    </Box>
  )
}

export default SendingComponent
